import { IAssignedPostcode } from "./IAssignedPostcode";
import { IPermission } from "./IPermission";
import { ISubCalendar } from "./ISubCalendar";

export interface IUser {
    id: number;
    username: string;
    first_name: string;
    last_name: string;
    email: string;
    is_superuser: boolean;
    profile: string;
    password: string;
}

export const RelationshipType = {
    Innendienst: 1,
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type RelationshipType = (typeof RelationshipType)[keyof typeof RelationshipType];

export const RelationshipDirection = {
    Incoming: "incoming",
    Outgoing: "outgoing",
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type RelationshipDirection = (typeof RelationshipDirection)[keyof typeof RelationshipDirection];

export interface IRelationship {
    direction: RelationshipDirection
    peer: number;
    type: RelationshipType;
}

export interface IProfile {
    id: number;
    mobile_number: string;
    phone_number: string;

    sub_calendars: number[];
    //permissions: IPermission[];
    User: IUser;
    Role?: number;
    assigned_postcodes?: IAssignedPostcode[];
    relationships: IRelationship[];
}

export interface IUserSmall {
    id: number;
    first_name: string;
    last_name: string;
    profile: null | {
        id: number;
        Role: number;
    };
}
